document.addEventListener('DOMContentLoaded', function () {

    // Remove from cart
	function handleRemoveFromCart(event) {
		event.preventDefault();

		const prodId = event.currentTarget.getAttribute('data-prod-id');
		const prodQty = event.currentTarget.getAttribute('data-prod-qty');
		const prodName = event.currentTarget.getAttribute('data-prod-name');
		const prodPrice = event.currentTarget.getAttribute('data-prod-price');
		const prodCurrency = event.currentTarget.getAttribute('data-prod-curr');

		window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: "remove_from_cart",
                ecommerce: {
                    currency: prodCurrency,
                    value: prodPrice,
                    items: [
                        {
                            item_id: prodId,
                            item_name: prodName,
                            quantity: prodQty
                        }
                    ]
                }
        });
	}

	const removeLinks = document.querySelectorAll('.cart__trash a');
    if(removeLinks){
        removeLinks.forEach((link) => {
            link.addEventListener('click', handleRemoveFromCart);
        });
    }

    function handleAddToCart(event) {
		event.preventDefault();

		const prodId = event.currentTarget.getAttribute('data-prod-id');
		const prodQty = event.currentTarget.getAttribute('data-prod-qty');
		const prodName = event.currentTarget.getAttribute('data-prod-name');
		const prodPrice = event.currentTarget.getAttribute('data-prod-price');
		const prodCurrency = event.currentTarget.getAttribute('data-prod-curr');

		window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: "add_to_cart",
                ecommerce: {
                    currency: prodCurrency,
                    value: prodPrice,
                    items: [
                        {
                            item_id: prodId,
                            item_name: prodName,
                            quantity: prodQty
                        }
                    ]
                }
        });
	}

    // Add to cart
	const cartLinks = document.querySelectorAll('.product__body-bag, .product__body-bag-big');
    if(cartLinks){
        cartLinks.forEach((link) => {
            link.addEventListener('click', handleAddToCart);
        });
    }
});
